module.exports = __webpack_public_path__ + "assets/img/00006.216457f4.png";